/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    Error500LicensePlateCodeEnum,
    Error404CodeEnum,
    Error500CodeEnum,
    Error504CodeEnum,
} from 'client-code/device-binding-service';
import { ErrorTypes } from './ErrorTypes';
import { SignInError } from './SignInError';

export class LicensePlateError extends SignInError {
    TAG: string = 'LicensePlateError';

    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.message = message;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case Error500LicensePlateCodeEnum.DbsDynamodbError:
                this.code = ErrorTypes.SIGN_IN_LICENSE_PLATE_DYNAMODB_ERROR_C501;
                this.type = Error500LicensePlateCodeEnum.DbsDynamodbError;
                break;

            case Error500CodeEnum.DbsGaError:
                this.code = ErrorTypes.SIGN_IN_LICENSE_PLATE_GA_ERROR_C502;
                this.type = Error500CodeEnum.DbsGaError;
                break;

            case Error504CodeEnum.DbsIntegrationTimeout:
                this.code = ErrorTypes.SIGN_IN_LICENSE_PLATE_INTEGRATION_TIMEOUT_C503;
                this.type = Error504CodeEnum.DbsIntegrationTimeout;
                break;

            case Error404CodeEnum.DbsResourceNotFound:
                this.code = ErrorTypes.SIGN_IN_LICENSE_PLATE_RESOURCE_NOT_FOUND_C504;
                this.type = Error404CodeEnum.DbsResourceNotFound;
                break;

            default:
                this.code = ErrorTypes.SIGN_IN_LICENSE_PLATE_UNKNOWN_ERROR_C599;
                this.type = 'LICENSE_PLATE_UNKNOWN_ERROR';
        }
    }
}
